export const LOCAL_STORAGE_KEY = {
    CSRF_TOKEN: "csrfToken",
    AUTH_ERROR: "authError",
    INITIAL_PATH: "initialPath",
};
